// Library Methods
import { ReactNode } from "react";
import { useTranslation } from "react-i18next";

// Components
import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";
import CautionsList from "./CautionsList";

export const NothingToSummarise = () => {
  const { t } = useTranslation();
  return (
    <Typography fontSize="12px" color="#5B6D7A">
      {t("Nothing to summarize — this module isn't complete.")}
    </Typography>
  );
};

type SummaryCardType = {
  title: ReactNode;
  cautions: Array<string> | null;
  children: ReactNode;
  // Drops the body's side padding, for content that brings its own spacing (e.g. trial cards).
  disableContentPadding?: boolean;
};

const SummaryCard = ({
  title,
  cautions,
  children,
  disableContentPadding = false,
}: SummaryCardType) => {
  const { t } = useTranslation();
  return (
    <Box
      sx={{
        display: "flex",
        flexDirection: "column",
        gap: disableContentPadding ? "0px" : "8px",
        border: "1px solid #000",
        borderRadius: "4px",
      }}
    >
      <Box
        sx={{
          display: "flex",
          flexWrap: "wrap",
          alignItems: "center",
          gap: "8px",
          background: "#000",
          color: "#FFF",
          padding: "8px",
          fontSize: "14px",
          fontWeight: 600,
        }}
      >
        {title}
      </Box>
      <Box sx={{ px: disableContentPadding ? 0 : "8px" }}>{children}</Box>
      {cautions !== null && (
        <Box sx={{ p: "8px", borderTop: "1px solid #5B6D7A40" }}>
          <Typography
            fontSize="12px"
            sx={{
              color: "#5B6D7A",
              textTransform: "uppercase",
              mb: "4px",
            }}
          >
            {t("Cautions")}
          </Typography>
          <CautionsList cautions={cautions} />
        </Box>
      )}
    </Box>
  );
};

export default SummaryCard;
